import React from 'react';
import { Form, RequiredHelpPhrase, Row, SubmitButton, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ContentSelectComboBoxForForm2, ListBoxModifier } from '../../../components/molecules/Form/components/ComboBox';
import { CalendarForm } from '../CalendarTypes';
import { RowModifier } from '../../../_lib/Form2/grid/Row/Row';

type CalendarAddFormProps = {
  form: CalendarForm;
  refresh(): void;
};

export function CalendarAddOrUpdateForm({ form, refresh }: CalendarAddFormProps) {
  const { t } = useSonTranslation('Calendar');

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: refresh,
  });

  const comboboxParam = params.getByName('targetCalendarId');

  return (
    <Form id="celandar-form" {...formProps}>
      <RequiredHelpPhrase />
      <Row modifier={RowModifier.BLOCK}>
        <ContentSelectComboBoxForForm2
          name={comboboxParam.name}
          suggestUrl={comboboxParam.comboBoxUrl.url}
          modifierListBox={ListBoxModifier.RELATIVE}
          labelTitle={t('addForm.combobox.title')}
          required={comboboxParam.required}
        />
      </Row>
      <SubmitButton
        buttonLabel={t('phrases:saveChanges')}
        messageSuccess={t('addForm.status.success')}
        messageSending={t('addForm.status.sending')}
        messageFail={t('addForm.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
